export default __webpack_public_path__ + "static/media/moneyKeeper.7d5dfcc2.png";